module.exports = __webpack_public_path__ + "static/media/4-15.2a401ff5.png";